import { render } from "./VCookiesManagerModal.vue?vue&type=template&id=3567fcef&ts=true"
import script from "./VCookiesManagerModal.vue?vue&type=script&lang=ts"
export * from "./VCookiesManagerModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__